// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HLJ6","placeholdersHeader":"styles_placeholdersHeader__3l3vo","editorStyle":"styles_editorStyle__r-im6","placeholdersBox":"styles_placeholdersBox__1yxZY"};